// This is color used for table highlight both for tanstack and custom made tables
export const highlightColor = "#dceaf7"
